export default "__VITE_ASSET__BYHxJYxK__"